import { Link, useSearchParams } from 'react-router-dom';

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const orderNo = params.get('no');

  return (
    <section className="success-page">
      <div className="container">
        <div className="success-card">
          <div className="success-tick"><i className="fas fa-check" /></div>
          <h2>Order Placed!</h2>
          <p className="muted">
            Thank you for your order. We've received it and will start preparing it right away.
          </p>
          {orderNo ? <div className="order-no">Order No. <strong>{orderNo}</strong></div> : null}
          <div className="success-actions">
            <Link className="consult-btn" to="/account">View My Orders</Link>
            <Link className="link-btn" to="/">Continue Shopping</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
